import { render } from "./ServiceSelect.vue?vue&type=template&id=55e8687f&scoped=true"
import script from "./ServiceSelect.vue?vue&type=script&lang=js"
export * from "./ServiceSelect.vue?vue&type=script&lang=js"

import "./ServiceSelect.vue?vue&type=style&index=0&id=55e8687f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e8687f"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QIcon,QMenu,QBanner,QSelect,QItem,QItemSection,QItemLabel,QTooltip});
